import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "admin-section" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NcCheckboxRadioSwitch = _resolveComponent("NcCheckboxRadioSwitch")!
  const _component_NcNoteCard = _resolveComponent("NcNoteCard")!
  const _component_NcTextField = _resolveComponent("NcTextField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", null, _toDisplayString(_ctx.$options.title), 1),
    _createElementVNode("p", null, [
      _createTextVNode(_toDisplayString(_ctx.t('memories', 'Live transcoding provides for adaptive streaming of videos using HLS.')) + " ", 1),
      _cache[8] || (_cache[8] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t(
          'memories',
          'Note that this may be very CPU intensive without hardware acceleration, and transcoding will not be used for external storage.',
        )) + " ", 1),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        modelValue: _ctx.enableTranscoding,
        "onUpdate:modelValue": [
          _cache[0] || (_cache[0] = ($event: any) => ((_ctx.enableTranscoding) = $event)),
          _cache[1] || (_cache[1] = ($event: any) => (_ctx.update('memories.vod.disable', !_ctx.enableTranscoding)))
        ],
        type: "switch"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Enable Transcoding')), 1)
        ]),
        _: 1
      }, 8, ["modelValue"]),
      (_ctx.status)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createVNode(_component_NcNoteCard, {
              type: _ctx.binaryStatusType(_ctx.status.ffmpeg)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.binaryStatus('ffmpeg', _ctx.status.ffmpeg)), 1)
              ]),
              _: 1
            }, 8, ["type"]),
            _createVNode(_component_NcNoteCard, {
              type: _ctx.binaryStatusType(_ctx.status.ffprobe)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.binaryStatus('ffprobe', _ctx.status.ffprobe)), 1)
              ]),
              _: 1
            }, 8, ["type"])
          ], 64))
        : _createCommentVNode("", true),
      _createVNode(_component_NcTextField, {
        label: _ctx.t('memories', 'ffmpeg path'),
        "label-visible": true,
        "model-value": _ctx.config['memories.vod.ffmpeg'],
        onChange: _cache[2] || (_cache[2] = ($event: any) => (_ctx.update('memories.vod.ffmpeg', $event.target.value))),
        disabled: !_ctx.enableTranscoding
      }, null, 8, ["label", "model-value", "disabled"]),
      _createVNode(_component_NcTextField, {
        label: _ctx.t('memories', 'ffprobe path'),
        "label-visible": true,
        "model-value": _ctx.config['memories.vod.ffprobe'],
        onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.update('memories.vod.ffprobe', $event.target.value))),
        disabled: !_ctx.enableTranscoding
      }, null, 8, ["label", "model-value", "disabled"]),
      _cache[9] || (_cache[9] = _createElementVNode("br", null, null, -1)),
      _createTextVNode(" " + _toDisplayString(_ctx.t('memories', 'Global default video quality (user may override)')) + " ", 1),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.video_default_quality'],
        "onUpdate:modelValue": [
          _cache[4] || (_cache[4] = ($event: any) => ((_ctx.config['memories.video_default_quality']) = $event)),
          _cache[5] || (_cache[5] = ($event: any) => (_ctx.update('memories.video_default_quality')))
        ],
        value: "0",
        name: "vdq_radio",
        type: "radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Auto (adaptive transcode)')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"]),
      _createVNode(_component_NcCheckboxRadioSwitch, {
        disabled: !_ctx.enableTranscoding,
        modelValue: _ctx.config['memories.video_default_quality'],
        "onUpdate:modelValue": [
          _cache[6] || (_cache[6] = ($event: any) => ((_ctx.config['memories.video_default_quality']) = $event)),
          _cache[7] || (_cache[7] = ($event: any) => (_ctx.update('memories.video_default_quality')))
        ],
        value: "-1",
        name: "vdq_radio",
        type: "radio"
      }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.t('memories', 'Original (transcode with max quality)')), 1)
        ]),
        _: 1
      }, 8, ["disabled", "modelValue"])
    ])
  ]))
}